import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { SelectChangeEventDetail } from '@ionic/angular';
import { IonSelectCustomEvent } from '@ionic/core';
import { GlobalService } from '../services/global.service';
import { AlertController } from '@ionic/angular';

import { ModalController } from '@ionic/angular';
import { FormModalComponent } from '../components/form-modal/form-modal.component';


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit{

  // Detect click outside the dropdown and search input
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const dropdown = document.querySelector('.dropdown-list');
    const searchBox = document.querySelector('ion-input');
    
    // Check if the click was outside both the dropdown and the search input
    if (dropdown && !dropdown.contains(event.target as Node) && searchBox && !searchBox.contains(event.target as Node)) {
      this.filteredTextItems = []; // Hide the dropdown when clicked outside
    }
  }

  
  clientname: string | null | undefined;
  
  textItems: any[] = []; // Array to store retrieved items
  currentIndex: number = 1; // Index to track current item
  currentText: any = null; // Current item to display
  errorMessage: string = '';
  languageText !: string;
  skipTextFun() {
      this.retriveTextFun();
      this.isRecording = false;

      this.endClick = false;
      this.startClick = false;

      this.pauseClick = false;
      this.audioChunks = [];
      this.recordedAudioUrl = '';


  }
  async onOptionChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
      this.filteredTextItems = []; //to dismiss the dropdown show during search
      this.searchTerm = null;


      this.globalService.logoutLoading();
      const updateLang = $event.detail.value;
      localStorage.setItem('language', updateLang);
      this.userLanguage = updateLang
      await this.retriveTextFun();
      this.currentIndex = 1;
      this.globalService.dismissLoading();


      this.endClick = false;
      this.pauseClick = false;
      this.audioChunks = [];
      this.recordedAudioUrl = '';
      this.stopPlayingSound();
  }


  async onOptionCategoryChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
    this.filteredTextItems = []; //to dismiss the dropdown show during search
    this.searchTerm = null;
    const updateTextCategory = $event.detail.value;
    localStorage.setItem('textCategory', updateTextCategory);
    this.textCategory = updateTextCategory
    
    this.currentIndex = 1;
    
    await this.retriveTextFun();

    this.endClick = false;
    this.pauseClick = false;
    this.audioChunks = [];
    this.recordedAudioUrl = '';
    this.stopPlayingSound();
  }
  retriveTextFun() {
     const lang = localStorage.getItem('language');
     this.selectedOption = localStorage.getItem('language');
    //  const lang = 'english';
     const cate = localStorage.getItem('textCategory');
    //  console.log("Cate on LOcalstorea is:",cate)
     this.apiService.retriveText(lang,cate).subscribe(
      (response) => {
        // console.log("RRRRRRRRRRRRRRR",response)
        // this.textItems = [
        //   {
        //     "TextId": "1",
        //     "Text": "A",
        //     "Language": "nl",
        //     "DateCreated": "2024-08-01 10:11:00",
        //     "DateModified": null
        //   },
        //   {
        //     "TextId": "2",
        //     "Text": "B",
        //     "Language": "nl",
        //     "DateCreated": "2024-08-01 10:11:00",
        //     "DateModified": null
        //   },
        //   {
        //     "TextId": "3",
        //     "Text": "C",
        //     "Language": "nl",
        //     "DateCreated": "2024-08-01 10:11:00",
        //     "DateModified": null
        //   }
        // ]
        this.textItems = [];
        this.textItems = response.data;
        console.log("response is:",response);
        // this.textFromServer = response.Text;
        this.idOfTextFromServer = response.TextId;
        // console.log("textFromServer",this.textFromServer);

        this.displayCurrentItem();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  textFromServer:string = "";
  idOfTextFromServer:string = "";
  countOfTextPerUser:string = "";
  endClick:boolean = false;
  startClick:boolean = false;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  recordedAudioUrl: string | null = null;
  audioBlob: Blob | null = null;
  pauseClick:boolean = false;
  isRecording: boolean = false;
  isPlaying:boolean = false;
  isPaused = false; 

  audioInstance !: HTMLAudioElement;

  userName !: string | null;
  userLanguage !: string | null;
  textCategory !: string | null;
  userAccent !: string | null;
  userAge !: string | null;
  userGender !: string | null;
  userId !: string | null;

  selectedOption !: string | null;
  options = [
      { label: 'Dutch', value: 'nl' },
      { label: 'English', value: 'english' },
  ];
  selectedOptionCategory : string | null = 'all';
  options_category = [
    { label: 'All', value: 'all' },
    { label: 'PrioritizeText', value: 'prioritize_text' },
    { label: 'MozillaText', value: 'mozilla_text' },
    { label: 'Text', value: 'text' },
    { label: 'SurveyForms', value: 'surveyforms' },
    { label: 'Character', value: 'character' },
    { label: 'Number', value: 'number' },
    { label: 'Outbound', value: 'outbound' },
  ]

  searchTerm !: string | null ;
  constructor(private alertCtrl: AlertController,private modalCtrl: ModalController,private router:Router,private apiService:ApiService, private globalService:GlobalService,private alertController: AlertController,) {
    
  }



  async openFormModal() {
    const modal = await this.modalCtrl.create({
      component: FormModalComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal', //custom class for styling
      componentProps:{
        'initiator':'home'
      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      console.log('Form Data:', data);
    }
  }



  ionViewWillLeave(): void {
    localStorage.removeItem('searchedText');
    localStorage.removeItem('totalCountData');
    localStorage.removeItem('textCategory')
  }
  
  ngOnInit(){

    
      
       this.textFromServer = '';
       this.countOfTextPerUser = '';
  }
  redirectToIndex(searchTerm: string | null){

    if(searchTerm){
     this.globalService.logoutLoading();


     const lang = localStorage.getItem('language');
     const cate = localStorage.getItem('textCategory');
     this.apiService.retriveText(lang,cate).subscribe(
      (response) => {
        
        this.textItems = response.data;
        const position = this.textItems.length
        this.currentIndex = position
        

        this.displayCurrentItem();
        this.globalService.dismissLoading();
      },
      (err) => {
        console.log(err);
        this.globalService.dismissLoading();
      }
    );

      }
  }

  async ionViewDidEnter(){
    localStorage.removeItem('notRemoveModelInferencingData');


    const state = history.state;
    if (state && state.callFunctionValue && state.langUpdate) {
      localStorage.setItem('language', state.langUpdate);
      this.selectedOption = state.langUpdate;
    }else{
      this.selectedOption = this.selectedOption || 'nl';
    }
    

    this.userName = localStorage.getItem('userName');
    this.userLanguage = localStorage.getItem('language');
    // this.selectedOption = 'nl';
    this.selectedOption = this.selectedOption || 'nl';

    this.textCategory = localStorage.getItem('textCategory')
    this.selectedOptionCategory = this.textCategory || 'all';
    this.userAccent = localStorage.getItem('accent');
    this.userAge = localStorage.getItem('age');
    this.userGender = localStorage.getItem('gender');
    this.userId = localStorage.getItem('userId');

    

    await this.retriveTextFun();


    if (state && state.callFunctionValue && state.langUpdate) {
      this.searchTerm = state.callFunctionValue
      this.selectedOption = state.langUpdate;
      this.redirectToIndex(this.searchTerm);
    }

  }

 
  

  startRecording() {
    this.startClick = true;
    navigator.mediaDevices.getUserMedia({ audio: true })
    .then((stream) => {
            this.isRecording = true;
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.start();

            this.mediaRecorder.ondataavailable = (event) => {
                this.audioChunks.push(event.data);
            };

            this.mediaRecorder.onstop = () => {
                this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                this.recordedAudioUrl = URL.createObjectURL(this.audioBlob);
            };
        })
        .catch((error) => {
            console.error('Error accessing microphone:', error);
        });
  }

  stopRecording() {
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }
    setTimeout(() => {
      this.playRecording();
    }, 500);
  }

  stopRecordingOnly(){
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }
  }

 
  playRecording() {
    if (this.isPlaying) {
        // If audio is already playing, pause it
        this.audioInstance.pause();
        this.isPlaying = false; // Update playing flag
        this.isPaused = true; // Set paused flag
    } else {
        if (this.recordedAudioUrl) {
            // If audio is not playing, start playing it
            this.audioInstance = new Audio(this.recordedAudioUrl);
            this.audioInstance.onended = () => {
                this.isPlaying = false;
                this.isPaused = false; // Reset paused flag
            };
            this.audioInstance.play();
            this.isPlaying = true;
            this.isPaused = false; // Reset paused flag
        }
    }
  }



  cleanRecording(){
    this.endClick = false;
    this.pauseClick = false;
    this.audioChunks = [];
    this.recordedAudioUrl = '';
    this.stopPlayingSound();
  }

  pauseRecording(){
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    this.pauseClick = true;
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
  }

  }

  continueRecording(){
    this.endClick = false;
    this.pauseClick = false;
    this.startRecording();
  }

  getTextModifiedDateById(textId: string): string | null {
    const item = this.textItems.find(item => item.TextId === textId);
    return item ? item.DateModified : null;
  }

  getUrlId(textId: string): string | null {
    const item = this.textItems.find(item => item.TextId === textId);
    return item ? item.Url : null;

    
  }

  // getText(textId: string): string | null {
  //   const item = this.textItems.find(item => item.TextId === textId);
  //   return item ? item.Text : null;
  // }

  saveRecording(){
    this.globalService.showLoading();
    this.stopPlayingSound();
    this.endClick = false;
    this.pauseClick = false;
    this.audioChunks = [];
    this.recordedAudioUrl = '';
    let idOfTextFromServer = this.idOfTextFromServer ||  localStorage.getItem('idOfTextFromServer') || "";
    const textdateModified = this.getTextModifiedDateById(this.idOfTextFromServer);
    const urlId = this.getUrlId(this.idOfTextFromServer);
    // const recorded_text = this.getText(this.idOfTextFromServer);


    // apicall to store data 
    try{
            if (this.audioBlob) {
              
              // Proceed with the API call
              this.apiService.addAudio(this.audioBlob, idOfTextFromServer,textdateModified).subscribe(
                  async (response) => {
                          console.log("Response after audio post:", response);

                          if(urlId){
                                console.log("make api call to update not recorded value")
                                this.apiService.removeRecordedWord(urlId, response["text"]).subscribe(
                                  (removeResponse) => {
                                    // Handle the response from the API call here
                                    console.log("Recorded word removed:", removeResponse);

                                    this.apiService.removeUrl(idOfTextFromServer).subscribe(
                                      async (response) => {
                                        console.log("Url from the data has been removed successfully.",response);
                                        
                                      },
                                      (err) => {
                                        console.error("Error during API call:", err);
                                      }
                                    );

                                    //call api to remove urls

                                  },
                                  (error) => {
                                    // Handle any errors that occurred during the API call
                                    console.error("Error occurred while removing recorded word:", error);
                                  }
                                );
                            
                          }



                          // Show success message
                          // this.retriveTextFun();
                          this.showNextItem();
                          
                          this.audioChunks = [];
                          this.recordedAudioUrl = '';
                          await this.globalService.dismissLoading();
                          // alert("Data has been saved");

                      },
                        (err) => {
                            console.error("Error during API call:", err);
                            alert("Failed to save data. Please try again.");
                            this.globalService.dismissLoading();

                        }
                    );
                } else {
                    console.warn("No audio data to save");
                    this.globalService.dismissLoading();

              }
        }catch (error) {
          console.error('Error saving data:', error);
          alert('Failed to save data. Please try again.');
          this.globalService.dismissLoading();
      }

  }

  async confirmLogout() {
    if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      }else{
        await this.LogoutFunction();
      }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');

          this.stopPlayingSound();
          this.endClick = false;
          this.pauseClick = false;
          this.audioChunks = [];
          this.recordedAudioUrl = '';
          this.textFromServer = "";
          this.countOfTextPerUser = "";

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
    


      
  };





  stopPlayingSound(){
    // Stop audio playback if the audio instance exists
    if (this.audioInstance) {
        this.audioInstance.pause();
        this.audioInstance.currentTime = 0; // Reset the audio time to the beginning
        this.isPlaying = false; // Reset the isPlaying flag
    }
  }

  hasUnsavedAudioData(): boolean {
      return this.audioChunks.length > 0;
  }

  // displayCurrentItem(): void {
  //   if (this.textItems.length > 0) {
  //     this.currentText = this.textItems[this.currentIndex - 1];
  //     console.log("CurrentText is:",this.currentText.Text)
  //     this.textFromServer = this.currentText.Text;
  //     if (this.textFromServer === undefined || this.textFromServer.trim() === '') {
  //       this.textFromServer = 'No data available'; // Message to display
  //     }
  //     this.idOfTextFromServer = this.currentText.TextId;

  //   } else {
  //     this.currentText = null;
  //     }
  // }

  displayCurrentItem(): void {
    const lang = localStorage.getItem('language');
    try {
      if (this.textItems.length > 0) {
        // Attempt to access and assign properties
        this.currentText = this.textItems[this.currentIndex - 1];
        
        
        // Check if currentText and its properties are defined
        if (this.currentText && this.currentText.Text) {
          console.log("CurrentText is:", this.currentText.Text);
          this.textFromServer = this.currentText.Text;
          // this.countOfTextPerUser = this.currentText.AudioTextCount?? 0;
          this.countOfTextPerUser = this.currentText.AudioTextCount === 0 ? "You've never spoken this text before." : "You've already spoken this text " + this.currentText.AudioTextCount + " times.";

          // console.log("AAAAAAAAAAudio Count for this is:",this.countOfTextPerUser)
          
          // Check for empty or undefined text
          if (this.textFromServer === undefined || this.textFromServer.trim() === '') {
            this.textFromServer = lang === 'nl'
              ? 'Er zijn geen gegevens beschikbaar voor deze index' // Dutch message
              : 'No data available for this index'; // Default message in English
          }
          
          this.idOfTextFromServer = this.currentText.TextId;
          localStorage.setItem('idOfTextFromServer',this.currentText.TextId);

        } else {
          // Handle case where currentText.Text is undefined or null
          throw new Error('Text is undefined or null');
        }
      } else {
        this.currentText = null;
      }
    } catch (error) {
      // Handle any errors that occur in the try block
      // console.error('An error occurred:', error.message);
      this.textFromServer = lang === 'nl'
              ? `Er zijn geen gegevens beschikbaar voor deze index. Totaal beschikbare gegevens  = ${this.textItems.length}` // Dutch message
              : `No data available for this index. Total data available = ${this.textItems.length}`;
      
    }
  }
  

  showNextItem(): void {
    this.filteredTextItems = []; //to dismiss the dropdown show during search
    this.searchTerm = null; //to reset the value at search box

    if (this.currentIndex < this.textItems.length) {
      this.currentIndex++;
      this.displayCurrentItem();
    }
  }

  showPreviousItem(): void {
    this.filteredTextItems = []; //to dismiss the dropdown show during search
    this.searchTerm = null; //to reset the value at search box
    
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.displayCurrentItem();
    }
  }

  showCurrentItem(): void {
    this.displayCurrentItem();
    
  }

  //stc-ai-516
  goToMenu() {
    this.router.navigate(['/menu']);
  }

  // Define the list of allowed client names
  allowedClients: Set<string> = new Set(['BAS','sabir', 'Harry', 'susan', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);
  // allowedClients: Set<string> = new Set(['BAS', 'Harry', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);

  async goToAdminPage() {
    this.clientname = localStorage.getItem('userName');
      // Check if clientname is in the allowedClients set
      if (this.clientname && this.allowedClients.has(this.clientname)) {
        this.router.navigate(['/admin']);
      } else {
        // Show a popup message if not allowed
        const alert = await this.alertController.create({
          header: 'Access Denied',
          message: 'Sorry, you do not have permission to access this page.',
          buttons: ['OK']
        });
        await alert.present();
      }
    }


    filteredTextItems: any[] = [];

    onSearchChange(event: any): void {
      const searchTerm = event.target.value.toLowerCase(); // Get the search term from the input
      if (searchTerm) {
        this.filteredTextItems = this.textItems.filter(item =>
          item.Text.toLowerCase().includes(searchTerm)
        );
      } else {
        this.filteredTextItems = []; // Hide dropdown if input is empty
      }
    }
    selectTextItem(item: any): void {
      this.filteredTextItems = [];
      
      
      this.searchTerm = item.Text;
      // this.filteredTextItems = []; // Hide dropdown after selection
      // console.log("FFFFFFFFf",this.filteredTextItems);

      if(this.searchTerm){


        // const position = this.textItems.map((item, index) => ({ ...item, index })) // Add indices to the items
        //       .filter(item => item.Text.toLowerCase().includes(this.searchTerm.toLowerCase())) // Match all words
        //       .map(item => item.index); // Extract the indices

        const position = this.textItems
            .map((item, index) => ({ ...item, index })) 
            .filter(item => item.Text.toLowerCase().includes(this.searchTerm?.toLowerCase() || "")) // Handle null
            .map(item => item.index);

        console.log(position); // Output: Array of matching positions

        // this.currentIndex = position + 1
        console.log(position);
        this.currentIndex = position[0] + 1
        console.log("Current Index is:",this.currentIndex)

        this.displayCurrentItem();
        this.searchTerm = '';

    
        // console.log('Filtered items:', filteredItems);
        console.log('Position of Filtered items:', position);
      }else{
        console.log("search term empty");
      }

    }


    onClickAddText(){
      this.router.navigate(['/addtext']);
    }

    onClickAddSoundText(){
      
      this.router.navigate(['/addsoundtext']);
    }


    async showAlert(textId: string, oldText: string) {
      const alert = await this.alertCtrl.create({
        header: 'Update Text',
        cssClass: 'custom-alert',
        inputs: [
          {
            name: 'newText',
            type: 'text',
            value: oldText, // Set existing text here
            placeholder: 'Enter new text here !!!'
          }
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Update',
            handler: (data) => {
              console.log('User Input:', data);
              const requestBody = {
                UpdatedText: data.newText  // Correct field name
              };
              if (data.newText) {
                this.apiService.updateText(textId, requestBody).subscribe(
                  async (response) => {
                    console.log("Data has been updated successfully.");
                    this.currentText.Text = response["text"];
                    this.textFromServer = response["text"];
                  },
                  (err) => {
                    console.error("Error during API call:", err);
                  }
                );
              } else {
                console.warn("No audio data to save");
              }
            }
          }
        ]
      });
    
      await alert.present();
    }
    
    
    

    updateText(){
      this.currentText;
      console.log("Text updated ssssssssssssss.",this.currentText);
      this.showAlert(this.currentText.TextId,this.currentText.Text)
    }

  

}
